import React from 'react';
import { EditButton, Datagrid, TextField, DateField } from 'react-admin';
import AmountField from '../../components/fields/AmountField';
import TList from '../../components/wrapper/TList';

const FeeDefinitionList = props => (
	<TList exporter={false} {...props} filter={{ walletId: '' }}>
		<Datagrid>
			<EditButton />
			<TextField source="id" sortable={false} />
			<TextField source="subsidiaryId" sortable={false} />
			<TextField source="feeGroupId" sortable={false} />
			<DateField source="creationDateTime" showTime sortable={false} />
			<TextField source="feeType" sortable={false} />
			<TextField source="vatType" sortable={false} />
			<TextField source="customType" sortable={false} />
			<TextField source="description" sortable={false} />
			<TextField source="feeContext" sortable={false} />
			<TextField source="feeCurrency" sortable={false} />
			<TextField source="walletCountry" sortable={false} />
			<TextField source="userVerificationLevel" sortable={false} />
			<AmountField source="validFromAmount" sortable={false} />
			<AmountField source="validUntilAmount" sortable={false} />
			<DateField source="validFrom" showTime sortable={false} />
			<DateField source="validUntil" showTime sortable={false} />
			<AmountField source="baseAmount" sortable={false} />
			<AmountField source="minAmount" sortable={false} />
			<AmountField source="maxAmount" sortable={false} />
			<TextField source="rate" sortable={false} />
			<TextField source="amountGranularity" sortable={false} />
			<TextField source="paymentMethod" sortable={false} />
		</Datagrid>
	</TList>
);

export default FeeDefinitionList;
